// extracted by mini-css-extract-plugin
export default {"iconOther":"card-details_iconOther__a71RL","iconStatusYes":"card-details_iconStatusYes__dekUD","row":"card-details_row__fu0e0"};